import { IResourceComponentsProps } from '@refinedev/core';
import { AntdShowInferencer } from '@refinedev/inferencer/antd';

export const BlogPostShow: React.FC<IResourceComponentsProps> = () => {
  return <AntdShowInferencer />;
};
